import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

interface Props {
  form: LeaveForm
  canApproveLeaves: boolean
  hasTimeoffManager: boolean
}

export type Role = 'admin' | 'basic'

const useCurrentEmployeeRole = ({ canApproveLeaves, hasTimeoffManager, form }: Props): Role => {
  if (canApproveLeaves || !hasTimeoffManager || form.isSickType()) {
    return 'admin'
  }

  return 'basic'
}

export default useCurrentEmployeeRole
